import React, { useCallback } from 'react';

import { Card, Col, Form, Row, Button, InputGroup, Dropdown, Spinner, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import paths from 'routes/paths';
import { useState } from 'react';
import {useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import PrescriptionModal from './PrescriptionModal';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'helpers/api';
import MaskedInput from 'react-text-mask';
import moment from "moment";
import { toast } from 'react-toastify';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import MedicationInstructionsModal from './MedicationInstructionsModal';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import Select from 'react-select';
import { FixedSizeList as List } from "react-window";
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import SpecialInstructionInput from './SpecialInstructionInput';
import ReasonsInput from './ReasonsInput';
import AsyncSelect from 'react-select/async';
import OldPrescriptionModal from './OldPrescriptionModal';
import DiscontinuePrescriptionModal from './DiscontinuePrescriptionModal';
import VitalsChecklistModal from './VitalsChecklistModal';
import { useUnsavedChanges } from './UnsavedChangesContext';


const AddEditPrescription = () => {
    const height = 35;
    let initialFormData = {
        facilityname: '',
        individual: '',
        hcp: '',
        drugid: '',
        pres_drug: '',
        drug_form: '',
        ndc: '',
        brand: '',
        generic: '',
        amt: '',
        dose: '',
        freq: '',
        route: '',
        startdate: '',
        stopdate: '',
        //expirydate: '',
        rxnumber: '',
        rsnpres: '',
        splins: '',
        callhcp: '',
        pharma: 0,
        medgrp: '',
        med_status: '',
        earlyLateTime: '',
        exceeddate: '',
        timebetweenmeds: '',
        is_medsheet: true,
        is_treatment: false,
        is_physpres: false,
        is_vital: false,
        is_prnmedication: false,
        time1: '0',
        time2: '0',
        time3: '0',
        time4: '0',
        time5: '0',
        time6: '0',
        time7: '0',
        time8: '0',
        patient_name: '',
        hcp_name: '',
        special_instruction_text: '',
        reason_text: '',
        drugunit: '',
        is_reActivate: false,
        med_type : 'O',
        last_tran_prescription_id: '',
    };
    const [showOldPrescription, setShowOldPrescription] = useState(false);
    const [medicationIdentifier, setMedicationIdentifier] = useState('O');
    const [showShimmer, setShowShimmer] = useState(false);
    const [showVerifyShimmer, setShowVerifyShimmer] = useState(false);
    const [showModalInstruction, setShowModalInstruction] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [splitData, setSplitData] = useState(null);
    const [selectedVitals, setSelectedVitals] = useState([]);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialFormData);
    const [selectedHcp, setSelectedHcp] = useState(null);
    const [selectedFreq, setSelectedFreq] = useState(null);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [hcp, setHcp] = useState([]);
    const [checked, setChecked] = useState(false);
    const [edittimeclicked, setEditTimeClicked] = useState(false);
    const [showVitals, setShowVitals] = useState(false);
    const [patientOptions, setPatientOptions] = useState([]);
    const [startdate, setStartDate] = useState(null);
    const [stopdate, setStopDate] = useState(null);
    const [expirydate, setExpiryDate] = useState(null);
    const [splitObj, setSplitObj] = useState([]);
    // const [earlylatedate, setEarlyLateDate] = useState(null);
    // const [timebetweenmeds, setTimeBetweenMeds] = useState(null);
    const [defaultDrug, setDefaultDrug] = useState(null);
    const [vitals, setVitals] = useState([]);
    const [time1options, setTime1] = useState([]);
    const [time2options, setTime2] = useState([]);
    const [time3options, setTime3] = useState([]);
    const [time4options, setTime4] = useState([]);
    const [time5options, setTime5] = useState([]);
    const [time6options, setTime6] = useState([]);
    const [time7options, setTime7] = useState([]);
    const [time8options, setTime8] = useState([]);
    const [timeData, setTimeData] = useState({
        time1: "",
        time2: "",
        time3: "",
        time4: "",
        time5: "",
        time6: "",
        time7: "",
        time8: "",
    })
    const[is_dc, setIsDc] = useState(false);
    const[is_dcText, setIsDcText] = useState('');
    const { isDirty, setIsDirty } = useUnsavedChanges();
    const [facilityoptions, setFacilityOptions] = useState([]);
    // const [patientoptions, setPatientOptions] = useState([]);
    const [hcpoptions, setHcpOptions] = useState([]);
    // const [presdrugoptions, setPresDrugOptions] = useState([]);
    const [amtOptions, setAmtOptions] = React.useState([]);
    const [freqOptions, setFreqOptions] = React.useState([]);
    const [routeOptions, setRouteOptions] = React.useState([]);
    const [rsnOptions, setRsnOptions] = React.useState([]);
    const [splInsOptions, setSplinsOptions] = React.useState([]);
    const [pharmacyOptions, setPharmacyOptions] = React.useState([]);
    const [medgroupOptions, setMedGroupOptions] = React.useState([]);
    const [facilityName, setFacilityName] = useState('');
    const [drugUnitOptions, setDrugUnitOptions] = useState([]);
    const [vitalOptions, setVitalOptions] = useState([]);
    const [earlyLateTime, setEarlyLateTime] = useState("00:00");
    const [timeBetweenOtherMed, setTimeBetweenOtherMed] = useState("00:00");
    const [timeBetweenDoses, setTimeBetweenDoses] = useState("00:00");
    const [timeForEffect, setTimeForEffect] = useState("00:00");
    const [showDropdown, setShowDropdown] = useState(false);
    const [showTimeBetweenOtherMedDropdown, setShowTimeBetweenOtherMedDropdown] = useState(false);
    const [showTimeBetweenDosesDropdown, setShowTimeBetweenDosesDropdown] = useState(false);
    const [showTimeForEffectDropdown, setShowTimeForEffectDropdown] = useState(false);
    const [DCModalShow, setDCModalShow] = useState(false);
    const [dcData, setDcData] = useState(null);
    const [theme, setTheme] = useState(document.documentElement.getAttribute('data-bs-theme') || 'light');
    const { id } = useParams();
    const [validateVitalsParent, setValidateVitalsParent] = useState(false);
    const locationData = {
        orderid: id
    }
    let facilitiesData = JSON.parse(localStorage.getItem("facilitiesData"));
    const selectedFacility = facilitiesData.filter(facility => String(facility.value) == localStorage.getItem('facilityId'))
    const location = useLocation();
    const props = location.state;

    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();

    const handleShow = () => setShowModalInstruction(true);
    const handleClose = useCallback(() => {
        setShowModalInstruction(false);
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
          const newTheme = document.documentElement.getAttribute('data-bs-theme');
          setTheme(newTheme || 'light');
        });
      
        observer.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['data-bs-theme'],
        });
      
        return () => observer.disconnect();
      }, []);

    const handleTimeChange = (type, direction) => {
        let [hours, minutes] = earlyLateTime.split(":").map(Number);
        if (type === "hours") {
            hours = direction === "up" ? (hours + 1) % 24 : (hours - 1 + 24) % 24;
        } else {
            minutes = direction === "up" ? (minutes + 1) % 60 : (minutes - 1 + 60) % 60;
        }
        setEarlyLateTime(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
    };


    const handleCloseModal = () => {
        setValidateVitalsParent(true);

        const hasError = vitals.some(v =>
            v.is_active === 1 &&
            (
                v.threshold_min === "" ||
                v.threshold_max === "" ||
                (v.threshold_min_2 !== null && v.threshold_min_2 === "") ||
                (v.threshold_max_2 !== null && v.threshold_max_2 === "")
            )
        );

        if (hasError) return; // ❌ STOP CLOSE

        setShowVitals(false); // ✅ CLOSE
    };

    const handleTimeBetweenOtherMeds = (type, direction) => {
        let [hours, minutes] = timeBetweenOtherMed.split(":").map(Number);
        if (type === "hours") {
            hours = direction === "up" ? (hours + 1) % 24 : (hours - 1 + 24) % 24;
        } else {
            minutes = direction === "up" ? (minutes + 1) % 60 : (minutes - 1 + 60) % 60;
        }
        setTimeBetweenOtherMed(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
    };

    const handleTimeBetweenDoses = (type, direction) => {
        let [hours, minutes] = timeBetweenDoses.split(":").map(Number);
        if (type === "hours") {
            hours = direction === "up" ? (hours + 1) % 100 : (hours - 1 + 100) % 100;
        } else {
            minutes = direction === "up" ? (minutes + 1) % 60 : (minutes - 1 + 60) % 60;
        }
        setTimeBetweenDoses(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
    };

    const handleTimeForEffect = (type, direction) => {
        let [hours, minutes] = timeForEffect.split(":").map(Number);
        if (type === "hours") {
            hours = direction === "up" ? (hours + 1) % 100 : (hours - 1 + 100) % 100;
        } else {
            minutes = direction === "up" ? (minutes + 1) % 60 : (minutes - 1 + 60) % 60;
        }
        setTimeForEffect(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
    };

    const handleInputClick = () => {
        setShowDropdown(!showDropdown);
    };

    const handleTimeBetweenOtherMedInputClick = () => {
        setShowTimeBetweenOtherMedDropdown(!showTimeBetweenOtherMedDropdown);
    };

    const handleTimeBetweenDosesInputClick = () => {
        setShowTimeBetweenDosesDropdown(!showTimeBetweenDosesDropdown);
    };

    const handleTimeForEffectInputClick = () => {
        setShowTimeForEffectDropdown(!showTimeForEffectDropdown);
    };

    const handleTimeInputChange = (e) => {
        let value = e.target.value.replace(/[^\d:]/g, "");

        if (value.length <= 5) {
            if (e.target.name == 'timeForEffect') {
                setTimeForEffect(value);
            } else if (e.target.name == 'timeBetweenOtherDoses') {
                setTimeBetweenDoses(value);
            }
        }
    };


    const formatTime = (e) => {
        
        let [hours = "0", minutes = "0"] = e.target.name == 'timeForEffect' ? timeForEffect.split(":") : e.target.name == 'timeBetweenOtherDoses' ? timeBetweenDoses.split(":") : ["0", "0"];

        hours = Math.min(parseInt(hours || 0), 99);
        minutes = Math.min(parseInt(minutes || 0), 59);

        setTimeForEffect(
            `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
        );
    };


    const handleDropdownClose = () => {
        setShowDropdown(false);
    };

    const handleTimeBetweenOtherMedDropdownClose = () => {
        setShowTimeBetweenOtherMedDropdown(false);
    };

    const handleTimeBetweenDosesDropdownClose = () => {
        setShowTimeBetweenDosesDropdown(false);
    };

    const handleTimeForEffectDropdownClose = () => {
        setShowTimeForEffectDropdown(false);
    };

    const MenuList = (props) => {
        const { options, children, maxHeight, getValue } = props;
        const value = getValue();
        const initialOffset = options.findIndex((option) => option.value === value?.value);
      
        return (
          <List
            height={maxHeight}
            itemCount={children.length}
            itemSize={height}
            initialScrollOffset={initialOffset * height} // Scroll to selected value
            width="100%"
          >
            {({ index, style }) => <div style={style}>{children[index]}</div>}
          </List>
        );
      };

    useEffect(() => {
        populateData();
    }, []);

    const loadOptions = async (inputValue) => {
            if (!inputValue) return [];
    
            try {
                const tokenStr = localStorage.getItem("accessToken");
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER_URL}/drugs/search-drug`,
                    { search: inputValue },
                    { headers: { Authorization: `Bearer ${tokenStr}` } }
                );
    
                const data = response.data.data.map((value) => ({
                    key: `${value.drug || ""} ${value.strength_value || ""} ${value.strength || ""} ${value.drug_form || ""}`.trim(),
                    value: value.id + "|" + value.drug + "|" + (value.brand_drug != null ? value.brand_drug : "") + "|" + (value.ndc != null ? value.ndc : "") + "|" + (value.drug_form != null ? value.drug_form : "") + "|" + (value.generic != null ? value.generic : ""),
                }));
    
                setPatientOptions(data); // optional if you need to store elsewhere
                return data; // IMPORTANT: return the options to show in dropdown
            } catch (error) {
                console.error("Error loading patients:", error);
                return [];
            }
        };

    useEffect(() => {
        if (selectedVitals?.length) {
            setVitals(selectedVitals);
        }
    }, [selectedVitals]);

    const handleOpenVitals = () => {
        setVitals(prev => [...prev]);
        setShowVitals(true);
    };

    async function populateData() {
        let drugResults = [];
        let tokenStr = localStorage.getItem("accessToken");
        let results = JSON.parse(localStorage.getItem("facilitiesData"));
        //console.log("Facility Points " + results);

        setFacilityOptions([
            { key: 'Select a facility', value: '' },
            ...results
        ]);


        let getAllItems = locationData.orderid != null ?
            {
                prescription: {
                    id: locationData.orderid
                },
                //drug: {},
                amount: {},
                frequency: {},
                reason: {},
                route: {},
                special_instruction: {},
                pharmacy_store: {},
                medgroup: {},
                doctor: {},
                prescription_hour: {},
                drug_unit : {},
                vitals : {}
            } :
            {
                //drug: {},
                amount: {},
                frequency: {},
                reason: {},
                route: {},
                special_instruction: {},
                pharmacy_store: {},
                medgroup: {},
                doctor: {},
                prescription_hour: {},
                drug_unit : {},
                vitals : {}
            };

        // if(locationData.orderid == null){
        //     await axios.get(`${process.env.REACT_APP_SERVER_URL}/drugs/list-drugs`, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
        //     .then((res) => {

        //         let objDrugData = {};

        //         //localStorage.setItem("ogdrugData", JSON.stringify(objDrugData));

        //         objDrugData.forEach((value) => {
        //             let drugBrand = value.brand_drug != null ? value.brand_drug : "";
        //             let drugNdc = value.ndc != null ? value.ndc : "";
        //             let drugForm = value.drug_form != null ? value.drug_form : "";
        //             let drugGeneric = value.generic != null ? value.generic : "";

        //             drugResults.push({
        //                 key: value.drug + " " + value.strength_value || "" + " " + value.strength || "",
        //                 value: value.id + "|" + value.drug + "|" + drugBrand + "|" + drugNdc + "|" + drugForm + "|" + drugGeneric,
        //             });
        //         })
        //     });
        // }

        await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
            .then((res) => {
                /**********************DRUGS*****************************/

                //console.log("Major Data " + JSON.stringify(res.data));

                // setPresDrugOptions([
                //     { key: 'Select a Drug', value: '' },
                //     ...drugResults
                // ]);

                 let objVitalData = res.data.output.data["vitals"];
                 setVitalOptions([
                    ...objVitalData
                 ])
                /**********************DRUG UNIT************************ */
                let objDrugUnitData = res.data.output.data["drug_unit"];
                let drugUnitResults = [];
                objDrugUnitData.forEach((value) => {
                    if (value.unit != null && value.unit != "") {
                        drugUnitResults.push({
                            key: value.unit,
                            value: value.id,
                        });
                    }
                })
                setDrugUnitOptions([
                    { key: 'Select Drug Unit', value: '' },
                    ...drugUnitResults
                ])
                /**********************AMOUNT*****************************/

                let objAmountData = res.data.output.data["amount"];
                let amtResults = [];

                objAmountData.forEach((value) => {
                    if (value.amount != null && value.amount != "") {
                        amtResults.push({
                            key: value.amount,
                            value: value.id,
                        });
                    }
                });

                setAmtOptions([
                    { key: 'Select Amount', value: '' },
                    ...amtResults
                ]);

                /**********************FREQUENCY*****************************/

                let objFreqData = res.data.output.data["frequency"];
                let freqResults = [];

                objFreqData.forEach((value) => {
                    if (value.name != null && value.name != "") {
                        freqResults.push({
                            key: value.name,
                            value: value.id,
                        });
                    }
                });

                setFreqOptions([
                    { key: 'Select Frequency', value: '' },
                    ...freqResults
                ]);

                /**********************ROUTE*****************************/

                let objRouteData = res.data.output.data["route"];
                let routeResults = [];

                objRouteData.forEach((value) => {
                    if (value.route != null && value.route != "") {
                        routeResults.push({
                            key: value.route,
                            value: value.id,
                        });
                    }
                });

                setRouteOptions([
                    { key: 'Select Route', value: '' },
                    ...routeResults
                ]);

                /**********************REASON*****************************/

                let objReasonData = res.data.output.data["reason"];
                let reasonResults = [];

                objReasonData.forEach((value) => {

                    if (value.reason != null && value.reason != "") {
                        reasonResults.push({
                            key: value.reason,
                            value: value.id,
                        });
                    }
                });

                setRsnOptions([
                    // { key: 'Select Reason', value: '' },
                    ...reasonResults
                ]);

                /**********************INSTRUCTIONS*****************************/

                let objInsData = res.data.output.data["special_instruction"];
                let insResults = [];

                objInsData.forEach((value) => {

                    if (value.instruction != null && value.instruction != "") {
                        insResults.push({
                            key: value.instruction,
                            value: value.id,
                        });
                    }
                });

                setSplinsOptions([
                    // { key: 'Select Special Instruction', value: '' },
                    ...insResults
                ]);

                /**********************PHARMACY STORE*****************************/

                let objPharmacyData = res.data.output.data["pharmacy_store"];
                let pharmacyResults = [];

                objPharmacyData.forEach((value) => {

                    if (value.pharmacy_store_name != null && value.pharmacy_store_name != "") {
                        pharmacyResults.push({
                            key: value.pharmacy_store_name,
                            value: value.id,
                        });
                    }
                });

                setPharmacyOptions([
                    { key: 'Select Pharmacy', value: '' },
                    ...pharmacyResults
                ]);

                /**********************MED GROUP*****************************/

                let objMedgroupData = res.data.output.data["medgroup"];
                let medgroupResults = [];

                objMedgroupData.forEach((value) => {

                    if (value.name != null && value.name != "") {
                        medgroupResults.push({
                            key: value.name,
                            value: value.id,
                        });
                    }
                });

                setMedGroupOptions([
                    { key: 'Select MedGroup', value: '' },
                    ...medgroupResults
                ]);

                /**********************TIME*****************************/

                let objHrData = res.data.output.data["prescription_hour"];
                let hrResults = [];

                objHrData.forEach((value) => {

                    if (value.time != null && value.time != "") {
                        hrResults.push({
                            key: value.time,
                            value: value.id,
                        });
                    }
                });

                setTime1([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime2([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime3([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime4([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime5([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime6([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime7([{ key: 'Select Time', value: '' }, ...hrResults]);
                setTime8([{ key: 'Select Time', value: '' }, ...hrResults]);


                /**********************EDIT PRESCRIPTION*****************************/
                if (locationData.orderid != null) {
                    let objPrescriptionData = res.data.output.data["prescription"];
                    setModalData(res.data.output.data);
                    setSplitObj(res.data.output.data.prescription[0]?.splitmeds);
                    setSplitData(res.data.output.data.prescription[0]?.splitmeds);
                    setSelectedVitals(res.data.output.data.prescription[0]?.vital_signs)
                    let facilityId = objPrescriptionData[0]?.facility_id
                    setFacilityName(results.filter(value => value.value == facilityId))

                    /**********************RX Number*****************************/
                    // let prescriptionResults = JSON.parse(localStorage.getItem("prescriptionObjData"));
                    // let rx_number = "";
                    // if(prescriptionResults){
                    //     prescriptionResults?.forEach((value) => {
    
                    //         if (locationData.orderid == value.id) {
                    //             rx_number = value.pharmacy_order_id;
                    //         }
    
                    //     });
                    // }


                    /**********************RX Number*****************************/
                    objPrescriptionData.forEach((singlePrescription) => {
                        setDcData(singlePrescription);
                        setIsDc(singlePrescription.discontinued_date != null);
                        setIsDcText(singlePrescription.discontinued_note != null ? singlePrescription.discontinued_note : '');
                        //console.log("singlePrescription " + JSON.stringify(singlePrescription));
                        // fetchPatientData(singlePrescription.facility_id);
                        // if (!locationData.orderid) {
                            // fetchHcpData(singlePrescription.facility_id);
                        // }
                        if((locationData.orderid != null)){
                            setDefaultDrug({
                                key: `${singlePrescription.drug || ""} ${singlePrescription.strength_value || ""} ${singlePrescription.strength || ""} ${singlePrescription.drug_form || ""}`.trim(),
                                value: `${singlePrescription.drug_id}|${singlePrescription.drug}|${singlePrescription.brand_drug}|${singlePrescription.drug_ndc}|${singlePrescription.drug_form}|${singlePrescription.generic}`
                            });
                        }
                        drugResults.forEach((singleDrug) => {
                            if((singlePrescription.drug + " " + singlePrescription.strength_value + " " + singlePrescription.strength) === singleDrug.key){
                                setDefaultDrug(singleDrug);
                            }

                            let singleDrugValueArr = singleDrug.value.split("|");

                            if (singleDrugValueArr[0] == singlePrescription.drug_id) {

                                singlePrescription.drug_id = singleDrugValueArr[0];
                                singlePrescription.drug = singleDrugValueArr[1];
                                singlePrescription.brand_drug = singleDrugValueArr[2];
                                singlePrescription.drug_ndc = singleDrugValueArr[3];
                                singlePrescription.drug_form = singleDrugValueArr[4];
                                singlePrescription.generic = singleDrugValueArr[5];
                            }

                            //console.log("singlePrescription " + singlePrescription.drug_id + singlePrescription.drug + "|" + singlePrescription.brand_drug + "|" + singlePrescription.drug_ndc + "|" + singlePrescription.drug_form + "|" + singlePrescription.generic,);

                        });
                        setTimeData({
                            time1 : singlePrescription.time_1,
                            time2 : singlePrescription.time_2,
                            time3 : singlePrescription.time_3,
                            time4 : singlePrescription.time_4,
                            time5 : singlePrescription.time_5,
                            time6 : singlePrescription.time_6,
                            time7 : singlePrescription.time_7,
                            time8 : singlePrescription.time_8,
                        })
                            let freqObj = freqResults.filter((singleFreq) => {
                                return Number(singleFreq.value) == Number(singlePrescription.frequency_id);
                            })
                            setSelectedFreq(freqObj)
                            let routeObj = routeResults.filter((singleFreq) => {
                                return Number(singleFreq.value) == Number(singlePrescription.route_id);
                            })
                            setSelectedFreq(freqObj)
                            setSelectedRoute(routeObj)
                            setMedicationIdentifier(singlePrescription.med_type);
                        setFormData({
                            facilityname: singlePrescription.facility_id,
                            individual: singlePrescription.patient_id,
                            hcp: singlePrescription.doctor_id,
                            pres_drug: singlePrescription.drug_id + "|" + singlePrescription.drug + "|" + singlePrescription.brand_drug + "|" + singlePrescription.drug_ndc + "|" + singlePrescription.drug_form + "|" + singlePrescription.generic,
                            drug_form: singlePrescription.drug_form,
                            ndc: singlePrescription.drug_ndc,
                            rxnumber: singlePrescription.pharmacy_order_id,
                            brand: singlePrescription.brand_drug,
                            generic: singlePrescription.generic,
                            dose: singlePrescription.dose,
                            callhcp: singlePrescription.remarks,
                            pharma: singlePrescription.pharmacy_store_id,
                            medgrp: singlePrescription.medgroup_id,
                            splins: singlePrescription.special_instruction_id,
                            route: singlePrescription.route_id,
                            freq: singlePrescription.frequency_id,
                            rsnpres: singlePrescription.reason_id,
                            amt: singlePrescription.amount_id,
                            med_status: singlePrescription.medication_independent_status,
                            exceeddate: singlePrescription.not_exceed,
                            is_medsheet: singlePrescription.mar_flag == 0 ? false : true,
                            is_treatment: singlePrescription.tar_flag == 0 ? false : true,
                            is_physpres: singlePrescription.po_flag == 0 ? false : true,
                            // is_vital: singlePrescription.has_vitalsigns == 0 ? false : true,
                            // med_type: singlePrescription.med_type,
                            is_prnmedication: singlePrescription.med_type == "P" ? true : false,
                            time1: singlePrescription.time_1,
                            time2: singlePrescription.time_2,
                            time3: singlePrescription.time_3,
                            time4: singlePrescription.time_4,
                            time5: singlePrescription.time_5,
                            time6: singlePrescription.time_6,
                            time7: singlePrescription.time_7,
                            time8: singlePrescription.time_8,
                            special_instruction_text: singlePrescription.special_instruction_text,
                            reason_text: singlePrescription.reason_text,
                            patient_name: (`${singlePrescription.patient_lastname},${singlePrescription.patient_firstname}`),
                            hcp_name: (`${singlePrescription.doctor_lastname},${singlePrescription.doctor_firstname}`),
                            is_splitmeds: singlePrescription.is_splitmeds,
                            drugunit: singlePrescription.drugunit_id,
                            last_tran_prescription_id : singlePrescription.last_tran_prescription_id,
                        });

                        setStartDate(singlePrescription.client_startdate != "" ? moment(singlePrescription.client_startdate, 'MM/DD/YY').format('MM/DD/YY') : null);//// uncomment after sometime

                        setStopDate(singlePrescription.client_stopdate != "" ? moment(singlePrescription.client_stopdate, 'MM/DD/YY').format('MM/DD/YY') : null);///// uncomment after sometime

                        setExpiryDate(singlePrescription.pharmacy_expire_date != "" ? moment(singlePrescription.pharmacy_expire_date, 'MM/DD/YY').format('MM/DD/YY') : null);///// uncomment after sometime

                        // setStartDate(singlePrescription.client_startdate != null ? moment(singlePrescription.client_startdate, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                        // setStopDate(singlePrescription.client_stopdate != null ? moment(singlePrescription.client_stopdate, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                        // setExpiryDate(singlePrescription.pharmacy_expire_date != null ? moment(singlePrescription.pharmacy_expire_date, 'YYYY-MM-DD').format('MM/DD/YY') : null);

                        setEarlyLateTime(singlePrescription.early != null ? singlePrescription.early : "00:00");
                        setTimeBetweenOtherMed(singlePrescription.time_between_meds != null ? singlePrescription.time_between_meds : "00:00");
                        setTimeBetweenDoses(singlePrescription.time_between_doses != null ? singlePrescription.time_between_doses : "00:00");
                        setTimeForEffect(singlePrescription.time_for_effect != null ? singlePrescription.time_for_effect : "00:00");

                        setChecked(singlePrescription.med_type == "P" ? true : false);
                    });

                };
                let hcpData = res.data.output.data["doctor"];
                setHcp(hcpData);
            });


        // fetchPatientData(formData.facilityname);

        // if (!locationData.orderid) { fetchHcpData(formData.facilityname); }

    }

    // async function fetchPatientData(facilityid) {

    //     let tokenStr = localStorage.getItem("accessToken");
    //     const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/patients/list-all-patients/" + facilityid, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
    //     let results = []

    //     //console.log("Patient Data Status " + data.status);
    //     let objPatientData = data.patients.data;

    //     objPatientData.forEach((value) => {
    //         results.push({
    //             key: value.first_name + ", " + value.last_name,
    //             value: value.id
    //         });
    //     });

    //     setPatientOptions([
    //         ...results
    //     ])

    // }

    // useEffect(() => {
    //     fetchHcpData(hcp);
    // },[formData.hcp,hcp])

    useEffect(() => {
        fetchHcpData(hcp);
    }, [formData.hcp,hcp]);

    async function fetchHcpData(objDoctorList) {    
        const results = objDoctorList.map(value => ({
            key: `${value.lastname} , ${value.firstname}`,
            value: value.id,
        }));
        const hcpOption = results.find(opt => opt.value === Number(formData.hcp));
        if (hcpOption) {
            setSelectedHcp(hcpOption);
        }
        setHcpOptions([
            ...results
        ])
    }

    // const handleFacilityFieldChange = e => {
    //     fetchPatientData(e.target.value);
    //     fetchHcpData(e.target.value);
    //     setFormData({
    //         ...formData,
    //         [e.target.name]: e.target.value
    //     });
    // }

    const handleDrugFieldChange = e => {
        let drugPres = e.value;
        // let drugPres = e.target.value;
        setDefaultDrug(e)
        let drugPresArr = drugPres.split("|");
        setFormData({
            ...formData,
            drugid: drugPresArr[0],
            pres_drug: drugPresArr[1],
            brand: drugPresArr[2],
            ndc: drugPresArr[3],
            drug_form: drugPresArr[4],
            generic: drugPresArr[5]
        });
    };

    const handlePrescriptionModal = (event) => {
        localStorage.setItem("prescriptionFormName", event.target.id);
        if (event.target.id == "btnfrequency") {
            localStorage.setItem("prescriptionModalFormValues", freqOptions);
        }
        setShowModal(true);
    };

    const validateVitals = () => {
        let isValid = true;
    
        const updated = selectedVitals?.map((v) => {
          if (v.is_active === 0) return v;
    
          if (
            v.threshold_min === "" ||
            v.threshold_max === "" ||
            v.threshold_min === null ||
            v.threshold_max === null
          ) {
            isValid = false;
          }
    
          if (v.threshold_min_2 !== null) {
            if (v.threshold_min_2 === "") isValid = false;
          }
    
          if (v.threshold_max_2 !== null) {
            if (v.threshold_max_2 === "") isValid = false;
          }
    
          return v;
        });
    
        return isValid;
      };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.is_prnmedication && !formData.is_splitmeds) {
            const hasSelectedTime = Object.values(timeData).some((value) => value);

            if (!hasSelectedTime) {
                newErrors.time = "At least one hour must be selected";
            }
        }

        if (!startdate) newErrors.startdate = "Start Date is required.";
        // if (!stopdate) newErrors.stopdate = "Stop Date is required.";
        if (!expirydate) newErrors.expirydate = "Expiry Date is required.";
        if (!formData.freq && !formData.is_splitmeds) newErrors.freq = "Select atleast one frequency.";
        if (!formData.amt && !formData.is_splitmeds) newErrors.amt = "Select atleast one amount or enter Manualy clicking on +";
        if (!formData.dose && !formData.is_splitmeds) newErrors.dose = "dose is required";
        if (!String(formData.rsnpres)?.trim() && !formData.reason_text.trim()) newErrors.rsnpres = "Select atleast one reason or enter Manualy clicking on +";
        if (!String(formData.splins)?.trim() && !formData.special_instruction_text?.trim()) newErrors.splins = "Select atleast one Special Instruction or enter Manualy clicking on +";
        if (!formData.pres_drug) newErrors.pres_drug = "Selection of Drug is Required";
        if (!formData.route) newErrors.route = "Select atleast one route or enter Manualy clicking on +";
        if (!formData.hcp) newErrors.hcp = "Selection of HCP is Required";
        if (!formData.drugunit) newErrors.drugunit = "Selection of Drug Unit is Required";
        if (!validateVitals()) {
            setShowVitals(true);
            newErrors.vitals = "Please fill all vital fields";
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async e => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        setIsDirty(false);
        setShowShimmer(true);
        if (e.target.name == "prescriptionform") {

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsPrescriptionUrl = locationData.orderid != null ? `${process.env.REACT_APP_SERVER_URL}/prescriptions/edit-prescription` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/add-prescriptions`;

            let amtManual = [];
            let freqManual = [];
            let routeManual = [];
            let rsnManual = [];
            let splInsManual = [];

            amtOptions.map((amtoption) => {

                if (amtoption.value == "-999") {
                    amtManual.push(amtoption.key);
                }
            });
            freqOptions.map((freqoption) => {

                if (freqoption.value == "-999") {
                    freqManual.push(freqoption.key);
                }
            });
            routeOptions.map((routeoption) => {

                if (routeoption.value == "-999") {
                    routeManual.push(routeoption.key);
                }
            });
            rsnOptions.map((rsnoption) => {

                if (rsnoption.value == "-999") {
                    rsnManual.push(rsnoption.key);
                }
            });
            splInsOptions.map((splinsoption) => {

                if (splinsoption.value == "-999") {
                    splInsManual.push(splinsoption.key);
                }
            });

            let pelmedsPrescriptionData = locationData.orderid != null ?
                {
                    id: locationData.orderid,
                    group_id: localStorage.getItem("groupId"),
                    facility_id: formData.facilityname,
                    patient_id: formData.individual,
                    doctor_id: formData.hcp,
                    drug_id: formData.drugid,
                    drug: formData.pres_drug.split("|")[1],
                    drug_form: formData.drug_form,
                    ndc: formData.ndc,
                    brand_drug: formData.brand,
                    generic: formData.generic,
                    dose: formData.dose,
                    amount_id: formData.amt,
                    amount_manual: amtManual.toString(),
                    frequency_id: selectedFreq.value,
                    frequency_manual: freqManual.toString(),
                    route_id: selectedRoute.value,
                    route_manual: routeManual.toString(),
                    // vital_signs: vitals,
                    is_splitmeds: formData.is_splitmeds ? 1 : 0,
                    client_startdate: startdate != null ? moment(startdate).format('MM/DD/YYYY') : null,
                    client_stopdate: stopdate != null ? moment(stopdate).format('MM/DD/YYYY') : null,
                    pharmacy_expire_date: expirydate != null ? moment(expirydate).format('MM/DD/YYYY') : null,
                    reason_id: formData.rsnpres,
                    reason_manual: rsnManual.toString(),
                    special_instruction_id: formData.splins,
                    special_instruction_manual: splInsManual.toString(),
                    remarks: formData.callhcp,
                    pharmacy_store_id: formData.pharma || 0,
                    medgroup_id: formData.medgrp,
                    medication_independent_status: formData.med_status,
                    early: earlyLateTime != null ? earlyLateTime : null,
                    //not_exceed: exceeddate != null ? moment(exceeddate, 'hh:mm').format('hh:mm') : null,
                    not_exceed: formData.exceeddate,
                    //time_between_meds: formData.timebetweenmeds,
                    time_between_meds: timeBetweenOtherMed != null ? timeBetweenOtherMed : null,
                    time_between_doses: timeBetweenDoses != null ? timeBetweenDoses : null,
                    time_for_effect: timeForEffect != null ? timeForEffect : null,
                    mar_flag: formData.is_medsheet ? 1 : 0,
                    tar_flag: formData.is_treatment ? 1 : 0,
                    has_vitalsigns: 1,
                    po_flag: formData.is_physpres ? 1 : 0,
                    med_type: formData.is_prnmedication ? "P" : medicationIdentifier == "P" ? "O" : medicationIdentifier,
                    time_1: !formData.is_prnmedication ? formData.time1 : '0',
                    time_2: !formData.is_prnmedication ? formData.time2 : '0',
                    time_3: !formData.is_prnmedication ? formData.time3 : '0',
                    time_4: !formData.is_prnmedication ? formData.time4 : '0',
                    time_5: !formData.is_prnmedication ? formData.time5 : '0',
                    time_6: !formData.is_prnmedication ? formData.time6 : '0',
                    time_7: !formData.is_prnmedication ? formData.time7 : '0',
                    time_8: !formData.is_prnmedication ? formData.time8 : '0',
                    drugunit_id: formData.drugunit,
                } :
                {
                    group_id: localStorage.getItem("groupId"),
                    facility_id: localStorage.getItem("facilityId"),
                    patient_id: localStorage.getItem("patientId"),
                    doctor_id: formData.hcp,
                    drug_id: formData.drugid,
                    drug: formData.pres_drug.split("|")[1],
                    drug_form: formData.drug_form,
                    ndc: formData.ndc,
                    is_splitmeds: formData.is_splitmeds ? 1 : 0,
                    brand_drug: formData.brand,
                    generic: formData.generic,
                    dose: formData.dose,
                    amount_id: formData.amt,
                    amount_manual: amtManual.toString(),
                    frequency_id: selectedFreq.value,
                    // vital_signs: vitals,
                    frequency_manual: freqManual.toString(),
                    route_id: selectedRoute.value,
                    route_manual: routeManual.toString(),
                    client_startdate: startdate != null ? moment(startdate).format('MM/DD/YYYY') : null,
                    client_stopdate: stopdate != null ? moment(stopdate).format('MM/DD/YYYY') : null,
                    pharmacy_expire_date: expirydate != null ? moment(expirydate).format('MM/DD/YYYY') : null,
                    reason_id: formData.rsnpres,
                    reason_manual: rsnManual.toString(),
                    special_instruction_id: formData.splins,
                    special_instruction_manual: splInsManual.toString(),
                    remarks: formData.callhcp,
                    pharmacy_store_id: formData.pharma || 0,
                    medgroup_id: formData.medgrp,
                    medication_independent_status: formData.med_status,
                    early: earlyLateTime != null ? earlyLateTime : null,
                    //not_exceed: exceeddate != null ? moment(exceeddate, 'hh:mm').format('hh:mm') : null,
                    //time_between_meds: formData.timebetweenmeds,
                    not_exceed: formData.exceeddate,
                    time_between_meds: timeBetweenOtherMed != null ? timeBetweenOtherMed: null,
                    time_between_doses: timeBetweenDoses != null ? timeBetweenDoses : null,
                    time_for_effect: timeForEffect != null ? timeForEffect : null,
                    mar_flag: formData.is_medsheet ? 1 : 0,
                    tar_flag: formData.is_treatment ? 1 : 0,
                    has_vitalsigns: 1,
                    po_flag: formData.is_physpres ? 1 : 0,
                    med_type: formData.is_prnmedication ? "P" : formData.med_type,
                    time_1: !formData.is_prnmedication ? formData.time1 : '0',
                    time_2: !formData.is_prnmedication ? formData.time2 : '0',
                    time_3: !formData.is_prnmedication ? formData.time3 : '0',
                    time_4: !formData.is_prnmedication ? formData.time4 : '0',
                    time_5: !formData.is_prnmedication ? formData.time5 : '0',
                    time_6: !formData.is_prnmedication ? formData.time6 : '0',
                    time_7: !formData.is_prnmedication ? formData.time7 : '0',
                    time_8: !formData.is_prnmedication ? formData.time8 : '0',
                    drugunit_id: formData.drugunit,
                }

                if (vitals.length > 0) {
                    pelmedsPrescriptionData.vital_signs = vitals;
                }

            //console.log("pelmedsPrescriptionData " + JSON.stringify(pelmedsPrescriptionData));
            console.log(pelmedsPrescriptionData)
            const { data } = await axios.post(pelmedsPrescriptionUrl, pelmedsPrescriptionData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const patientDetails = paths.patientDetails;
            if (data.status && locationData.orderid == null) {
                toast.success("Prescription Details added successfully");
                navigate(`${patientDetails}/${localStorage.getItem("patientId")}`);
            }
            else if (data.status && locationData.orderid != null) {
                toast.success("Prescription Details updated successfully");
                navigate(`${patientDetails}/${formData.individual}`);
            }
            else {
                setIsDirty(true);
                toast.error("Error while adding Prescription Details");
            }

            //if (locationData == null) {
            //    setFormData(initialFormData);
            //    formRef.current.reset();
            //}
            //console.log("DataOutput " + JSON.stringify(data));

        }
    };

    const handleReActivateClick = async(e) => {
        e.preventDefault();
        setShowVerifyShimmer(true);
        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsPrescriptionData = {
            id: locationData.orderid,
            undiscontinue: formData.is_reActivate ? 1 : 0,
        }

        let pelmedsPrescriptionUrl = `${process.env.REACT_APP_SERVER_URL}/prescriptions/edit-prescription`
        const { data } = await axios.post(pelmedsPrescriptionUrl, pelmedsPrescriptionData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        const patientDetails = paths.patientDetails;
        if (data.status) {
            toast.success(data.message);
            setShowVerifyShimmer(false);
            navigate(`${patientDetails}/${formData.individual}`);
        }
        else {
            toast.error(data.message);
        }
    }

    const handleVerifyClick = async e => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        setIsDirty(false);
        setShowVerifyShimmer(true);
        let amtManual = [];
        let freqManual = [];
        let routeManual = [];
        let rsnManual = [];
        let splInsManual = [];

        amtOptions.map((amtoption) => {

            if (amtoption.value == "-999") {
                amtManual.push(amtoption.key);
            }
        });
        freqOptions.map((freqoption) => {

            if (freqoption.value == "-999") {
                freqManual.push(freqoption.key);
            }
        });
        routeOptions.map((routeoption) => {

            if (routeoption.value == "-999") {
                routeManual.push(routeoption.key);
            }
        });
        rsnOptions.map((rsnoption) => {

            if (rsnoption.value == "-999") {
                rsnManual.push(rsnoption.key);
            }
        });
        splInsOptions.map((splinsoption) => {

            if (splinsoption.value == "-999") {
                splInsManual.push(splinsoption.key);
            }
        });
        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsPrescriptionData = {
            id: locationData.orderid,
            group_id: localStorage.getItem("groupId"),
            facility_id: formData.facilityname,
            patient_id: formData.individual,
            doctor_id: formData.hcp,
            drug_id: formData.drugid,
            drug: formData.pres_drug.split("|")[1],
            drug_form: formData.drug_form,
            ndc: formData.ndc,
            brand_drug: formData.brand,
            generic: formData.generic,
            dose: formData.dose,
            amount_id: formData.amt,
            amount_manual: amtManual.toString(),
            frequency_id: selectedFreq.value,
            frequency_manual: freqManual.toString(),
            route_id: selectedRoute.value,
            route_manual: routeManual.toString(),
            client_startdate: startdate != null ? moment(startdate).format('MM/DD/YYYY') : null,
            client_stopdate: stopdate != null ? moment(stopdate).format('MM/DD/YYYY') : null,
            pharmacy_expire_date: expirydate != null ? moment(expirydate).format('MM/DD/YYYY') : null,
            reason_id: formData.rsnpres,
            reason_manual: rsnManual.toString(),
            // vital_signs: vitals,
            special_instruction_id: formData.splins,
            special_instruction_manual: splInsManual.toString(),
            remarks: formData.callhcp,
            is_splitmeds: formData.is_splitmeds ? 1 : 0,
            pharmacy_store_id: formData.pharma || 0,
            medgroup_id: formData.medgrp,
            medication_independent_status: formData.med_status,
            early: earlyLateTime != null ? moment(earlyLateTime, 'hh:mm').format('hh:mm') : null,
            //not_exceed: exceeddate != null ? moment(exceeddate, 'hh:mm').format('hh:mm') : null,
            not_exceed: formData.exceeddate,
            //time_between_meds: formData.timebetweenmeds,
            time_between_meds: timeBetweenOtherMed != null ? timeBetweenOtherMed : null,
            time_between_doses: timeBetweenDoses != null ? timeBetweenDoses : null,
            time_for_effect: timeForEffect != null ? timeForEffect : null,
            mar_flag: formData.is_medsheet ? 1 : 0,
            tar_flag: formData.is_treatment ? 1 : 0,
            has_vitalsigns: 1,
            po_flag: formData.is_physpres ? 1 : 0,
            med_type: formData.is_prnmedication ? "P" : medicationIdentifier == "P" ? "O" : medicationIdentifier,
            time_1: !formData.is_prnmedication ? formData.time1 : '0',
            time_2: !formData.is_prnmedication ? formData.time2 : '0',
            time_3: !formData.is_prnmedication ? formData.time3 : '0',
            time_4: !formData.is_prnmedication ? formData.time4 : '0',
            time_5: !formData.is_prnmedication ? formData.time5 : '0',
            time_6: !formData.is_prnmedication ? formData.time6 : '0',
            time_7: !formData.is_prnmedication ? formData.time7 : '0',
            time_8: !formData.is_prnmedication ? formData.time8 : '0',
            is_verified: 1,
            drugunit_id: formData.drugunit,
        }

        if (vitals.length > 0) {
            pelmedsPrescriptionData.vital_signs = vitals;
        }
        let pelmedsPrescriptionUrl = locationData.orderid != null ? `${process.env.REACT_APP_SERVER_URL}/prescriptions/edit-prescription` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/add-prescriptions`;
        const { data } = await axios.post(pelmedsPrescriptionUrl, pelmedsPrescriptionData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        const patientDetails = paths.patientDetails;
        if (data.status && locationData.orderid != null) {
            toast.success("Prescription Details updated successfully");
            navigate(`${patientDetails}/${localStorage.getItem("patientId")}`);
        }
        else {
            setIsDirty(true);
            toast.error("Error while adding Prescription Details");
        }
    }

    const handleFieldChange = e => {
        setIsDirty(true);
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleHcpFieldChange = e => {
        setIsDirty(true);
        setFormData({
            ...formData,
            'hcp': e.value
        });
    };

    const handleFreqFieldChange = e => {
        setIsDirty(true);
        setSelectedFreq(e);
        setFormData({
            ...formData,
            'freq': e.value
        });
    };

    const handleRouteFieldChange = e => {
        setIsDirty(true);
        setSelectedRoute(e);
        setFormData({
            ...formData,
            'route': e.value
        });
    };

    const handleTimeFieldChange = e => {
        setIsDirty(true);
        setTimeData({ ...formData, [e.target.name]: e.target.value });

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        if (errors.time) {
            setErrors({ ...errors, time: "" });
        }
    };

    const validateExpiryDate = expirydate => {
        setIsDirty(true);
        // if (moment(expirydate) > moment(stopdate)) {
            setExpiryDate(expirydate)
        // } else {
        //     toast.info("Expiry date should be greater than Start/Stop Date");
        // }
    }

    const handlePrnMedication = (e) => {
        setIsDirty(true);
        const checked = e.target.checked;
        setChecked(checked);
        setFormData({
            ...formData,
            is_prnmedication: checked,
        });
    };

    const handleSplitMedication = (e) => { 
        setIsDirty(true);
        const checked = e.target.checked;
        // setChecked(checked);
        setFormData({
            ...formData,
            is_splitmeds: checked,
        });
    };

    const handleMoreTime = (e) => {
        if (!edittimeclicked)
            setEditTimeClicked(true);
    };

    const handlePrescriptionModalValue = (modalvalue) => {
        let formName = localStorage.getItem("prescriptionFormName");

        if (formName == "btnsplins") {
            let isDuplicate = handleDrpDuplicates(splInsOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate) {
                let updatedInsOptions = splInsOptions.filter((singleoption) => singleoption.value != -999);
                updatedInsOptions.push({ key: modalvalue, value: -999 });
                setSplinsOptions(updatedInsOptions);
                setFormData({
                    ...formData,
                    'splins': -999
                });
            }
        }
        else if (formName == "btnrsnpres") {
            let isDuplicate = handleDrpDuplicates(rsnOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate) {
                let updatedRsnOptions = rsnOptions.filter((singleoption) => singleoption.value != -999);
                updatedRsnOptions.push({ key: modalvalue, value: -999 });
                setRsnOptions(updatedRsnOptions);
                setFormData({
                    ...formData,
                    'rsnpres': -999
                });
            }
        }
        else if (formName == "btnroute") {
            let isDuplicate = handleDrpDuplicates(routeOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate) {
                let updatedRouteOptions = routeOptions.filter((singleoption) => singleoption.value != -999);
                updatedRouteOptions.push({ key: modalvalue, value: -999 });
                setRouteOptions(updatedRouteOptions);
                setFormData({
                    ...formData,
                    'route': -999
                });
            }
        }
        else if (formName == "btnfrequency") {
            let isDuplicate = handleDrpDuplicates(freqOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate) {
                let updatedFreqOptions = freqOptions.filter((singleoption) => singleoption.value != -999);
                updatedFreqOptions.push({ key: modalvalue, value: -999 });
                setFreqOptions(updatedFreqOptions);
                setFormData({
                    ...formData,
                    'freq': -999
                });
            }
        }
        else if (formName == "btnamt") {
            let isDuplicate = handleDrpDuplicates(amtOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate) {
                let updatedAmtOptions = amtOptions.filter((singleoption) => singleoption.value != -999);
                updatedAmtOptions.push({ key: modalvalue, value: -999 });
                setAmtOptions(updatedAmtOptions);
                setFormData({
                    ...formData,
                    'amt': -999
                });
            }
        }

        localStorage.setItem("prescriptionFormName", "");
        localStorage.setItem("prescriptionModalFormValues", "");

    };

    function handleDrpDuplicates(drpdwnOptions, modalvalue) {

        let isDuplicate = false;

        drpdwnOptions.map((singleoption) => {
            //console.log(singleoption.key + " && " + modalvalue);
            if (singleoption.key.toLowerCase() == modalvalue.toLowerCase()) {
                isDuplicate = true;
            }
        })

        return isDuplicate;
    }

// useEffect(() => {
//   const handleGlobalClick = (e) => {
//     const anchor = e.target.closest("a");

//     if (!anchor) return;

//     const href = anchor.getAttribute("href");

//     // ignore external links / empty
//     if (!href || href.startsWith("#") || href.startsWith("javascript:")) {
//       return;
//     }

//     if (isDirty) {
//       const confirmLeave = window.confirm(
//         "You have unsaved changes. Are you sure you want to leave?"
//       );
//       console.log("confirmLeave", confirmLeave);

//       if (!confirmLeave) {
//         e.preventDefault();
//         e.stopPropagation();
//       }
//     }
//   };

//   document.addEventListener("click", handleGlobalClick);

//   return () => {
//     document.removeEventListener("click", handleGlobalClick);
//   };
// }, [isDirty]);


    useEffect(() => {
        const handlePopState = (e) => {
            if (!isDirty) return;

            const confirmLeave = window.confirm(
                "You have unsaved changes. Are you sure you want to leave?"
            );

            if (confirmLeave) {
                setIsDirty(false);
            }

            if (!confirmLeave) {
                window.history.pushState(null, "", window.location.pathname);
            }
            console.log("confirmLeave", confirmLeave);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isDirty]);

useEffect(() => {
  window.history.pushState(null, "", window.location.pathname);
}, []);

    const breadcrumbItems = locationData.orderid ? [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Patient', href: paths.viewPatient, isActive: false },
        { name: formData?.patient_name ? formData?.patient_name.split(',')
                .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
                .join(',') : formData.patient_name.split(',')
                .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
                .join(','), href: `${paths.patientDetails}/${formData.individual}`, isActive: false },
        { name: 'Edit-Prescription', href: paths.editPrescription, isActive: true }

    ] : [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Patient', href: paths.viewPatient, isActive: false },
        {
            name: localStorage.getItem("patientName").split(',')
                .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
                .join(','), href: `${paths.patientDetails}/${localStorage.getItem("patientId")}`, isActive: false
        },
        { name: 'Add-Prescription', href: paths.addPrescription, isActive: true }
    ]

    //  const breadcrumbItems = locationData.orderid ? [
    //     { name: 'Dashboard', href: '/main', isActive: false },
    //     { name: 'Patient', href: paths.viewPatient, isActive: false },
    //     { name: props?.patientname ? props?.patientname.split(',')
    //             .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    //             .join(',') : formData.patient_name.split(',')
    //             .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    //             .join(','), href: `${paths.patientDetails}/${formData.individual}`, isActive: false },
    //     { name: 'Edit-Prescription', href: paths.editPrescription, isActive: true }

    // ] : [
    //     { name: 'Dashboard', href: '/main', isActive: false },
    //     { name: 'Patient', href: paths.viewPatient, isActive: false },
    //     { name: props?.patientname ? props?.patientname.split(',')
    //             .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    //             .join(',') : formData.patient_name.split(',')
    //             .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    //             .join(','), href: `${paths.patientDetails}/${props.patientid}`, isActive: false },
    //     { name: 'Add-Prescription', href: paths.addPrescription, isActive: true }
    // ]

    return (
        <>
            {amtOptions.length > 0 ? <>
                <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
                <OldPrescriptionModal
                    show={showOldPrescription}
                    onClose={() => setShowOldPrescription(false)}
                    prescriptionId={formData.last_tran_prescription_id}
                    masterData={{
                        amtOptions,
                        freqOptions,
                        routeOptions,
                        rsnOptions,
                        splInsOptions,
                        pharmacyOptions,
                        medgroupOptions,
                        drugUnitOptions,
                        time1options
                    }}
                />

                <Form onSubmit={handleSubmit} name="prescriptionform">
                    <MedicationInstructionsModal show={showModalInstruction} handleClose={handleClose} dataObj={modalData} splitObj={splitObj} onSaved={(rows) => setSplitObj(rows)}  />
                    {DCModalShow && <DiscontinuePrescriptionModal
                        prescriptionId={locationData.orderid}
                        show={DCModalShow}
                        onClose={() => setDCModalShow(false)}
                        dcData={dcData}
                    />}
                    <Card className="mb-3">
                        <Card.Header as="h6" className="bg-body-tertiary">
                            <Row className="mb-2">
                                <Col xs="3">
                                    {locationData.orderid != null ? "Id: " + locationData.orderid : ""}
                                </Col>
                                <Col xs="6" className='text-center'>
                                    {formData.last_tran_prescription_id && (
                                        // <span
                                        //     className="text-primary cursor-pointer"
                                        //     style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        //     onClick={() => setShowOldPrescription(true)}
                                        // >
                                            
                                        // </span>

                                        <span
                                            className="old-prescription-pill"
                                            onClick={() => setShowOldPrescription(true)}
                                        >
                                            <i className="fas fa-file-medical me-1" />
                                            Click here to view Old Prescription
                                        </span>

                                    )}
                                </Col>
                                {((is_dcText == null || is_dcText == "") && locationData.orderid != null) && <Col xs="3" className='text-end'>
                                   <Button variant="danger" size="sm" onClick={
                                    () => {
                                        setDCModalShow(true);  
                                   }}>
                                       DC Prescription
                                   </Button>
                                </Col>}
                            </Row>
                        </Card.Header>
                        <Card.Body>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Facility</Form.Label>
                                        <Form.Control
                                            name="facilityname"

                                            size="sm"
                                            disabled="disabled"
                                            defaultValue={locationData.orderid ? facilityName[0]?.key : selectedFacility[0].key}
                                        >
                                            {/* {facilityoptions.map((option) => {
                                        let isFacilitySelected = false;
                                        if (option.value == locationData.facilityid) {
                                            isFacilitySelected = "selected";
                                        }
                                        return (
                                            <option key={option.value} value={option.value} selected={isFacilitySelected} >
                                                {option.key}
                                            </option>
                                        );
                                    })} */}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                {locationData.orderid != null && (
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Rx Number</Form.Label>
                                            <Form.Control
                                                placeholder='Rx Number'
                                                value={formData.rxnumber}
                                                name="rxnumber"
                                                onChange={handleFieldChange}
                                                type="text"
                                                disabled="disabled"
                                                size="sm"
                                            />
                                        </Form.Group>
                                    </Col>)}
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Individual</Form.Label>
                                        <Form.Control
                                            name="individual"
                                            onChange={handleFieldChange}
                                            size="sm"
                                            disabled="disabled"
                                            value={facilityName[0]?.key ? formData.patient_name : localStorage.getItem("patientName")}>
                                            {/* <option key="Select Individual" value="">Select Individual</option>
                                    {patientoptions.map((option) => {
                                        var isPatientSelected = false;
                                        if (option.value == locationData.patientid) {
                                            isPatientSelected = "selected";
                                        }
                                        return (
                                            <option key={option.value} value={option.value} selected={isPatientSelected} >
                                                {option.key}
                                            </option>
                                        );
                                    })} */}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label className='required'>HCP</Form.Label>
                                        {(
                                            <ThemedSelect
                                                name="hcp"
                                                closeMenuOnSelect={true}
                                                placeholder='Select Hcp'
                                                classNamePrefix="react-select"
                                                options={hcpoptions}
                                                value={selectedHcp}
                                                isDisabled = {is_dc}
                                                getOptionLabel={option => option.key}
                                                getOptionValue={option => option.value}
                                                onChange={handleHcpFieldChange}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: "#ced4da",
                                                        boxShadow: "none",
                                                        "&:hover": { borderColor: "#80bdff" },
                                                    }),
                                                    option: (provided, { isFocused, isSelected }) => ({
                                                        ...provided,
                                                        backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                                        color: isSelected ? "#212529 !important" : "#212529 !important",
                                                        cursor: "pointer",
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: "#212529",
                                                    }),
                                                }}
                                            />)
                                        }
                                        {errors.hcp && <div className="invalid-feedback mt-1 display-block">{errors.hcp}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label className='required'>Dispensed Drug</Form.Label>
                                        {/* <ThemedSelect
                                            name="pres_drug"
                                            closeMenuOnSelect={true}
                                            placeholder="Select Drug"
                                            classNamePrefix="react-select"
                                            className={`${errors.pres_drug ? "is-invalid" : ""}`}
                                            value={defaultDrug}
                                            options={presdrugoptions}
                                            isDisabled={locationData.orderid != null}
                                            getOptionLabel={(option) => option.key}
                                            getOptionValue={(option) => option.value}
                                            components={{ MenuList }}
                                            onChange={(e) => handleDrugFieldChange(e)}
                                            styles={{
                                                control: (provided, state) => ({
                                                  ...provided,
                                                  backgroundColor: state.isDisabled ? "#edf2f9 !important" : "white",
                                                  color: state.isDisabled ? "#6c757d !important" : "black",
                                                  cursor: state.isDisabled ? "not-allowed !important" : "pointer",
                                                  border: "1px solid #ced4da !important",
                                                  boxShadow: "none !important",
                                                  "&:hover": {
                                                    borderColor: state.isDisabled ? "#ced4da !important" : "#80bdff",
                                                  },
                                                  opacity: state.isDisabled ? "1 !important" : "1",
                                                }),
                                                option: (provided, { isFocused, isSelected }) => ({
                                                    ...provided,
                                                    backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                                    color: isSelected ? "#212529 !important" : "#212529 !important",
                                                    cursor: "pointer",
                                                }),
                                                singleValue: (provided, state) => ({
                                                  ...provided,
                                                  color: state.isDisabled ? "#6c757d !important" : "#212529",
                                                }),
                                                placeholder: (provided, state) => ({
                                                  ...provided,
                                                  color: state.isDisabled ? "#6c757d !important" : "#6c757d",
                                                  opacity: "1 !important",
                                                }),
                                                dropdownIndicator: (provided, state) => ({
                                                  ...provided,
                                                  display: state.isDisabled ? "none !important" : "flex",
                                                }),
                                                indicatorSeparator: (provided, state) => ({
                                                  ...provided,
                                                  backgroundColor: state.isDisabled ? "transparent !important" : provided.backgroundColor,
                                                }),
                                              }}
                                             /> */}
                                        <AsyncSelect
                                            name="pres_drug"
                                            cacheOptions
                                            loadOptions={loadOptions}
                                            value={defaultDrug}
                                            isDisabled={locationData.orderid != null}
                                            defaultOptions={patientOptions}
                                            getOptionLabel={(option) => option.key}
                                            getOptionValue={(option) => option.value}
                                            // onChange={handleDrugFieldChange}
                                            onChange={(e) => handleDrugFieldChange(e)}
                                            placeholder="Start typing..."
                                            noOptionsMessage={({ inputValue }) => (!inputValue ? "Start typing" : "No options")}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isDisabled
                                                        ? (theme === 'light' ? '#edf2f9' : '#232e3c')
                                                        : (theme === 'dark' ? '#2d2f38' : 'white'),
                                                    // backgroundColor: theme === 'dark' ? '#2d2f38' : 'white',
                                                    color: theme === 'dark' ? '#f8f9fa' : '#212529',
                                                    border: '1px solid #ced4da',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        borderColor: '#80bdff'
                                                    }
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: theme === 'dark' ? '#2d2f38' : '#fff',
                                                    zIndex: 5
                                                }),
                                                option: (provided, { isFocused, isSelected }) => ({
                                                    ...provided,
                                                    backgroundColor: isSelected
                                                        ? theme === 'dark'
                                                            ? '#2d2f38'
                                                          :  '#e9ecef !important'
                                                        : isFocused
                                                            ? theme === 'dark'
                                                                ? '#3a3b3f'
                                                                : '#f8f9fa !important'
                                                            : theme === 'dark'
                                                                ? '#1e1f23'
                                                                : "white !important",
                                                    color: theme === 'dark' ? '#f8f9fa' : "#212529 !important",
                                                    cursor: 'pointer',
                                                }),
                                                singleValue: (provided, state) => ({
                                                    ...provided,
                                                    color: state.isDisabled ? '#6c757d' : (theme === 'dark' ? '#f8f9fa' : '#212529'),
                                                }),
                                                placeholder: (provided, state) => ({
                                                    ...provided,
                                                    color: '#6c757d',
                                                    opacity: 1,
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: theme === 'dark' ? '#f8f9fa' : '#212529'
                                                }),
                                                dropdownIndicator: (provided, state) => ({
                                                    ...provided,
                                                    display: state.isDisabled ? 'none' : 'flex',
                                                }),
                                                indicatorSeparator: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isDisabled ? 'transparent' : provided.backgroundColor,
                                                }),
                                            }}
                                        />
                                        {errors.pres_drug && <div className="invalid-feedback mt-1 display-block">{errors.pres_drug}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Drug Form</Form.Label>
                                        <Form.Control
                                            placeholder='Drug Form'
                                            value={formData.drug_form}
                                            name="drug_form"
                                            onChange={handleFieldChange}
                                            type="text"
                                            disabled="disabled"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>NDC</Form.Label>
                                        <Form.Control
                                            placeholder='NDC'
                                            value={formData.ndc}
                                            name="ndc"
                                            onChange={handleFieldChange}
                                            type="text"
                                            disabled="disabled"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Brand</Form.Label>
                                        <Form.Control
                                            placeholder='Brand'
                                            value={formData.brand}
                                            name="brand"
                                            onChange={handleFieldChange}
                                            type="text"
                                            disabled="disabled"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Generic</Form.Label>
                                        <Form.Control
                                            placeholder='Generic'
                                            value={formData.generic}
                                            name="generic"
                                            onChange={handleFieldChange}
                                            type="text"
                                            disabled="disabled"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className='mb-2'>
                                <Row className="mb-3 align-items-center">
                                    <Col>
                                        {!formData.is_splitmeds ? <Form.Check
                                            type="switch"
                                            name="is_prnmedication"
                                            id="is_prnmedication"
                                            disabled={is_dc}
                                            checked={formData.is_prnmedication}
                                            label="Check this Box For PRN Medications"
                                            className="mb-0"
                                            onChange={handlePrnMedication}
                                        /> : (!formData.is_prnmedication && formData.is_splitmeds) ? <Row className="mb-2">
                                            <Col className="d-flex justify-content-left">
                                                <Button size="sm" className='bg-success' onClick={handleShow}>
                                                    Split Meds
                                                </Button>
                                            </Col>
                                        </Row> : []}
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        {!formData.is_prnmedication && <Form.Check
                                            type="switch"
                                            id="is_splitmeds"
                                            name="is_splitmeds"
                                            label="Split Meds"
                                            // disabled={is_dc}
                                            checked={formData.is_splitmeds}
                                            onChange={handleSplitMedication}
                                            className="mb-0"
                                        />}
                                    </Col>
                                </Row>
                                {!formData.is_prnmedication && !formData.is_splitmeds && <Row className="align-items-end">
                                    <Form.Label className="required mb-2">Hour</Form.Label>
                                    <Col>
                                        <Form.Select
                                            name="time1"
                                            onChange={handleTimeFieldChange}
                                            size="sm"
                                            disabled={is_dc}
                                            value={formData.time1 ?? ""}
                                            className={errors.time ? "is-invalid" : ""}
                                        >
                                            {time1options.map(o => (
                                                <option key={o.value} value={o.value}>{o.key}</option>
                                            ))}
                                        </Form.Select>
                                        {errors.time ? <div className="invalid-feedback mt-1">{errors.time}</div> : null}
                                    </Col>
                                    <Col>
                                        <Form.Select
                                            name="time2"
                                            onChange={handleTimeFieldChange}
                                            size="sm"
                                            disabled={is_dc}
                                            value={formData.time2 ?? ""}
                                        >
                                            {time2options.map(o => (
                                                <option key={o.value} value={o.value}>{o.key}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col>
                                        <Form.Select
                                            name="time3"
                                            onChange={handleTimeFieldChange}
                                            size="sm"
                                            disabled={is_dc}
                                            value={formData.time3 ?? ""}
                                        >
                                            {time3options.map(o => (
                                                <option key={o.value} value={o.value}>{o.key}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col>
                                        <Form.Select
                                            name="time4"
                                            onChange={handleTimeFieldChange}
                                            size="sm"
                                            disabled={is_dc}
                                            value={formData.time4 ?? ""}
                                        >
                                            {time4options.map(o => (
                                                <option key={o.value} value={o.value}>{o.key}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs="auto">
                                        {locationData.orderid != null && (
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                id="btnmoretime"
                                                onClick={handleMoreTime}
                                            >
                                                +
                                            </Button>
                                        )}
                                    </Col>
                                </Row>}
                                {!formData.is_prnmedication && !formData.is_splitmeds && edittimeclicked && !checked && (
                                    <Row className="mt-2 mb-2 align-items-end">
                                        <Col>
                                            <Form.Select
                                                name="time5"
                                                onChange={handleTimeFieldChange}
                                                size="sm"
                                                disabled={is_dc}
                                                value={formData.time5 ?? ""}
                                            >
                                                {time5options.map(o => (
                                                    <option key={o.value} value={o.value}>{o.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                name="time6"
                                                onChange={handleTimeFieldChange}
                                                size="sm"
                                                disabled={is_dc}
                                                value={formData.time6 ?? ""}
                                            >
                                                {time6options.map(o => (
                                                    <option key={o.value} value={o.value}>{o.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                name="time7"
                                                onChange={handleTimeFieldChange}
                                                size="sm"
                                                disabled={is_dc}
                                                value={formData.time7 ?? ""}
                                            >
                                                {time7options.map(o => (
                                                    <option key={o.value} value={o.value}>{o.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                name="time8"
                                                onChange={handleTimeFieldChange}
                                                size="sm"
                                                disabled={is_dc}
                                                value={formData.time8 ?? ""}
                                            >
                                                {time8options.map(o => (
                                                    <option key={o.value} value={o.value}>{o.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col xs="auto">
                                            <Button variant="outline-secondary" size="sm" className="invisible">+</Button>
                                        </Col>
                                    </Row>
                                )}  
                            </div>
                            <Row className="mb-2">
                                {!formData.is_splitmeds && <Col xs="4">
                                    <Form.Group>
                                        <Form.Label className='required'>Amount</Form.Label>
                                        <InputGroup className="mb-3">
                                            <Form.Select
                                                name="amt"
                                                onChange={handleFieldChange}
                                                size="sm"
                                                disabled={is_dc || formData.is_splitmeds}
                                                isInvalid={!!errors.amt}
                                            >
                                                {amtOptions.map((amtoption) => {
                                                    var isAmtSelected = false;
                                                    if (locationData.orderid != null) {
                                                        if (amtoption.value == formData.amt) {
                                                            isAmtSelected = "selected";
                                                        }
                                                    }

                                                    if (amtoption.value == -999) {
                                                        isAmtSelected = "selected";
                                                    }

                                                    return (
                                                        <option key={amtoption.value} value={amtoption.value} selected={isAmtSelected}>
                                                            {amtoption.key}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            {Number(localStorage.getItem("roleId")) < 5 && <Button disabled={is_dc || formData.is_splitmeds} variant="outline-secondary" size="sm" id="btnamt" onClick={handlePrescriptionModal}>
                                                +
                                            </Button>}
                                            {errors.amt && <div className="invalid-feedback mt-1 display-block">{errors.amt}</div>}
                                        </InputGroup>
                                    </Form.Group>
                                </Col>}
                                <Col xs={!formData.is_splitmeds ? '4' : '6'}>
                                    <Form.Group>
                                        <Form.Label className='required'>Drug Unit</Form.Label>
                                        <InputGroup className="mb-3">
                                            <Form.Select
                                                name="drugunit"
                                                onChange={handleFieldChange}
                                                size="sm"
                                                disabled={is_dc}
                                                isInvalid={!!errors.drugunit}
                                            >
                                                {drugUnitOptions.map((amtoption) => {
                                                    var isAmtSelected = false;
                                                    if (locationData.orderid != null) {
                                                        if (amtoption.value == formData.drugunit) {
                                                            isAmtSelected = "selected";
                                                        }
                                                    }

                                                    return (
                                                        <option key={amtoption.value} value={amtoption.value} selected={isAmtSelected}>
                                                            {amtoption.key}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            {errors.drugunit && <div className="invalid-feedback mt-1 display-block">{errors.drugunit}</div>}
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                {!formData.is_splitmeds && <Col xs="4">
                                    <Form.Group>
                                        <Form.Label className='required'>Dose</Form.Label>
                                        <Form.Control
                                            placeholder='Dose'
                                            defaultValue={formData.dose}
                                            name="dose"
                                            disabled={is_dc || formData.is_splitmeds}
                                            onChange={handleFieldChange}
                                            type="text"
                                            size="sm"
                                            isInvalid={!!errors.dose}
                                        />
                                        {errors.dose && <div className="invalid-feedback mt-1 display-block">{errors.dose}</div>}
                                    </Form.Group>
                                </Col>}
                                {!formData.is_splitmeds && <Col xs= '6'>
                                    <Form.Group>
                                        <Form.Label className="required">Frequency</Form.Label>
                                        <div className="d-flex gap-2">
                                            <div style={{ flexGrow: 1 }}>
                                                <ThemedSelect
                                                    name="freq"
                                                    closeMenuOnSelect={true}
                                                    placeholder="Select frequency"
                                                    classNamePrefix="react-select"
                                                    options={freqOptions}
                                                    value={selectedFreq}
                                                    isDisabled={is_dc}
                                                    getOptionLabel={(option) => option.key}
                                                    getOptionValue={(option) => option.value}
                                                    onChange={handleFreqFieldChange}
                                                />
                                            </div>
                                            {Number(localStorage.getItem("roleId")) < 5 && (
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    disabled = {is_dc || formData.is_splitmeds}
                                                    id="btnfrequency"
                                                    onClick={handlePrescriptionModal}
                                                >
                                                    +
                                                </Button>
                                            )}
                                        </div>
                                        {errors.freq && <div className="invalid-feedback mt-1 display-block">{errors.freq}</div>}
                                    </Form.Group>
                                </Col>}
                                <Col xs = '6'>
                                    <Form.Group>
                                        <Form.Label className="required">Route</Form.Label>
                                        <div className="d-flex gap-2">
                                            <div style={{ flexGrow: 1 }}>
                                                <ThemedSelect
                                                    name="route"
                                                    closeMenuOnSelect={true}
                                                    placeholder="Select route"
                                                    classNamePrefix="react-select"
                                                    options={routeOptions}
                                                    value={selectedRoute}
                                                    isDisabled ={is_dc}
                                                    getOptionLabel={(option) => option.key}
                                                    getOptionValue={(option) => option.value}
                                                    onChange={handleRouteFieldChange}
                                                />
                                            </div>
                                            {Number(localStorage.getItem("roleId")) < 5 && (
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    disabled = {is_dc}
                                                    id="btnroute"
                                                    onClick={handlePrescriptionModal}
                                                >
                                                    +
                                                </Button>
                                            )}
                                        </div>
                                        {errors.route && <div className="invalid-feedback mt-1 display-block">{errors.route}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label className='required'>Start</Form.Label>
                                        {/* <DatePicker 
                                            name="startdate" 
                                            selected={startdate} 
                                            onChange={(startdate) => {
                                            setStartDate(startdate);
                                            }}
                                            className={`form-control form-control-sm ${errors.startdate ? 'is-invalid' : ''}`} 
                                            placeholderText="Select Start Date" 
                                            minDate={new Date()} /> */}
                                        
                                        <DatePicker
                                            disabled={is_dc}
                                            name="startdate" 
                                            placeholderText="Select Start Date"  
                                            className={`form-control form-control-sm ${errors.startdate ? 'is-invalid' : ''}`} 

                                            selected={startdate ? moment(startdate).format("MM/DD/YY") : null}
                                            onChange={(startdate) =>
                                                startdate != null ? setStartDate(moment(startdate).format("MM/DD/YY")) : setStartDate(null)
                                            }
                                            dateFormat="MM/dd/yy"
                                            // minDate={new Date()} 
                                        />

                                        {errors.startdate && <div className="invalid-feedback mt-1 display-block">{errors.startdate}</div>}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label >Stop</Form.Label>
                                            <DatePicker
                                                disabled={is_dc}
                                                name="stopdate" 
                                                placeholderText="Select Stop Date" 
                                                className={`form-control form-control-sm ${errors.stopdate ? 'is-invalid' : ''}`} 

                                                selected={stopdate != null ? moment(stopdate).format("MM/DD/YY") : null}
                                                onChange={(stopdate) =>
                                                    stopdate != null ? setStopDate(moment(stopdate).format("MM/DD/YY")) : setStopDate(null)
                                                }
                                                dateFormat="MM/dd/yy"
                                                // minDate={new Date()} 
                                            />
                                            {errors.stopdate && <div className="invalid-feedback mt-1 display-block">{errors.stopdate}</div>}
                                    </Form.Group>
                                </Col>
                                {<Col>
                                    <Form.Group>
                                        <Form.Label className='required'>Expiration</Form.Label>
                                        <DatePicker
                                            
                                            name="expirydate" 
                                            placeholderText="Select Expiry Date"
                                            className={`form-control form-control-sm ${errors.expirydate ? 'is-invalid' : ''}`}  
                                            disabled = {props?.from_ips && is_dc}
                                            selected={expirydate ? moment(expirydate).format("MM/DD/YY") : null}
                                            onChange={validateExpiryDate}
                                            dateFormat="MM/dd/yy"
                                            // minDate={new Date()} 
                                        />
                                        {errors.expirydate && <div className="invalid-feedback mt-1 display-block">{errors.expirydate}</div>}
                                    </Form.Group>
                                </Col>}
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label className='required'>Reason Prescribed</Form.Label>
                                        <ReasonsInput
                                            disabled = {is_dc}
                                            value={formData.rsnpres || formData.reason_text}
                                            splInsOptions={rsnOptions}
                                            formData={formData}
                                            setFormData={setFormData}
                                            handlePrescriptionModal={handlePrescriptionModal}
                                            errors={errors}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label className='required'>Special Instruction</Form.Label>
                                        <SpecialInstructionInput
                                            disabled = {is_dc}
                                            value={formData.splins || formData.special_instruction_text}
                                            splInsOptions={splInsOptions}
                                            formData={formData}
                                            setFormData={setFormData}
                                            handlePrescriptionModal={handlePrescriptionModal}
                                            errors={errors}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Call HCP If</Form.Label>
                                        <Form.Control
                                            placeholder='Call HCP If'
                                            disabled = {is_dc}
                                            value={formData.callhcp}
                                            name="callhcp"
                                            onChange={handleFieldChange}
                                            type="text"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Pharmacy</Form.Label>
                                        <Form.Select
                                            name="pharma"
                                            disabled = {is_dc}
                                            onChange={handleFieldChange}
                                            size="sm"
                                        >
                                            {pharmacyOptions.map((pharmaoption) => {
                                                var isPharmaSelected = false;
                                                if (locationData.orderid != null) {
                                                    if (pharmaoption.value == formData.pharma) {
                                                        isPharmaSelected = "selected";
                                                    }
                                                }
                                                return (
                                                    <option key={pharmaoption.value} value={pharmaoption.value} selected={isPharmaSelected}>
                                                        {pharmaoption.key}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Med Group</Form.Label>
                                        <Form.Select
                                            name="medgrp"
                                            onChange={handleFieldChange}
                                            size="sm"
                                            disabled = {is_dc}
                                        >
                                            {medgroupOptions.map((medgrpoption) => {
                                                var isMedGroupSelected = false;
                                                if (locationData.orderid != null) {
                                                    if (medgrpoption.value == formData.medgrp) {
                                                        isMedGroupSelected = "selected";
                                                    }
                                                }
                                                return (
                                                    <option key={medgrpoption.value} value={medgrpoption.value} selected={isMedGroupSelected}>
                                                        {medgrpoption.key}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Medication Status</Form.Label>
                                        <Form.Control
                                            placeholder='Medication Status'
                                            disabled = {is_dc}
                                            value={formData.med_status}
                                            name="med_status"
                                            onChange={handleFieldChange}
                                            type="text"
                                            size="sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    <Form.Group className="position-relative">
                                        <Form.Label>Early/Late</Form.Label>
                                        <Form.Control
                                            type="text"
                                            disabled = {is_dc}
                                            value={earlyLateTime}
                                            readOnly
                                            onClick={handleInputClick}
                                        />

                                        {showDropdown && (
                                            <Dropdown.Menu
                                                show
                                                className={`shadow-sm p-2 position-absolute w-50 rounded border 
        ${theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-white text-dark border-light'}`}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeChange("hours", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeChange("minutes", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                    <span className="text-center w-50">{earlyLateTime.split(":")[0]}</span>
                                                    <span className="text-center w-50">{earlyLateTime.split(":")[1]}</span>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeChange("hours", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeChange("minutes", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                </div>

                                                <div className="text-end mt-2">
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={handleDropdownClose}
                                                    >
                                                        Done
                                                    </Button>
                                                </div>
                                            </Dropdown.Menu>
                                        )}
                                    </Form.Group>
                                </Col>
                               {<Col>
                                    <Form.Group>
                                        <Form.Label>Not To Exceed</Form.Label>
                                        <Form.Control
                                            className="form-control form-control-sm"
                                            placeholder="Not To Exceed"
                                            onChange={handleFieldChange}
                                            size="sm"
                                            disabled = {is_dc || !formData.is_prnmedication}
                                            name="exceeddate"
                                            value={formData.exceeddate}
                                        />
                                    </Form.Group>
                                </Col>}
                                <Col>
                                    <Form.Group className="position-relative">
                                        <Form.Label>Time between other meds</Form.Label>
                                        <Form.Control
                                            type="text"
                                            disabled = {is_dc}
                                            value={timeBetweenOtherMed}
                                            readOnly
                                            onClick={handleTimeBetweenOtherMedInputClick}
                                        />

                                        {showTimeBetweenOtherMedDropdown && (
                                            <Dropdown.Menu
                                                show
                                                className={`shadow-sm p-2 position-absolute w-50 rounded border 
        ${theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-white text-dark border-light'}`}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenOtherMeds("hours", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenOtherMeds("minutes", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                    <span className="text-center w-50">{timeBetweenOtherMed.split(":")[0]}</span>
                                                    <span className="text-center w-50">{timeBetweenOtherMed.split(":")[1]}</span>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenOtherMeds("hours", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenOtherMeds("minutes", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                </div>

                                                <div className="text-end mt-2">
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={handleTimeBetweenOtherMedDropdownClose}
                                                    >
                                                        Done
                                                    </Button>
                                                </div>
                                            </Dropdown.Menu>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group className="position-relative">
                                        <Form.Label>Time between Doses</Form.Label>
                                        <Form.Control
                                            name='timeBetweenOtherDoses'
                                            type="text"
                                            disabled={is_dc || !formData.is_prnmedication}
                                            value={timeBetweenDoses}
                                            placeholder="HH:MM"
                                            onChange={handleTimeInputChange}
                                            onBlur={formatTime}
                                            onClick={handleTimeBetweenDosesInputClick}
                                        />

                                        {showTimeBetweenDosesDropdown && (
                                            <Dropdown.Menu
                                                show
                                                className={`shadow-sm p-2 position-absolute w-50 rounded border 
        ${theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-white text-dark border-light'}`}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenDoses("hours", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenDoses("minutes", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                    <span className="text-center w-50">{timeBetweenDoses.split(":")[0]}</span>
                                                    <span className="text-center w-50">{timeBetweenDoses.split(":")[1]}</span>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenDoses("hours", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeBetweenDoses("minutes", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                </div>

                                                <div className="text-end mt-2">
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={handleTimeBetweenDosesDropdownClose}
                                                    >
                                                        Done
                                                    </Button>
                                                </div>
                                            </Dropdown.Menu>
                                        )}
                                    </Form.Group>
                                </Col>
                                 <Col >
                                    <Form.Group className="position-relative">
                                        <Form.Label>Time to Document Response</Form.Label>
                                        <Form.Control
                                            name = 'timeForEffect'
                                            type="text"
                                            disabled={is_dc}
                                            value={timeForEffect}
                                            placeholder="HH:MM"
                                            onChange={handleTimeInputChange}
                                            onBlur={formatTime}
                                            onClick={handleTimeForEffectInputClick}
                                        />

                                        {showTimeForEffectDropdown && (
                                            <Dropdown.Menu
                                                show
                                                className={`shadow-sm p-2 position-absolute w-50 rounded border 
        ${theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-white text-dark border-light'}`}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeForEffect("hours", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeForEffect("minutes", "up")}
                                                    >
                                                        ▲
                                                    </Button>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                    <span className="text-center w-50">{timeForEffect.split(":")[0]}</span>
                                                    <span className="text-center w-50">{timeForEffect.split(":")[1]}</span>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeForEffect("hours", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        className={`p-0 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}
                                                        onClick={() => handleTimeForEffect("minutes", "down")}
                                                    >
                                                        ▼
                                                    </Button>
                                                </div>

                                                <div className="text-end mt-2">
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={handleTimeForEffectDropdownClose}
                                                    >
                                                        Done
                                                    </Button>
                                                </div>
                                            </Dropdown.Menu>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <div className="filters-section border rounded mt-3 mb-2 p-4 position-relative">
                                    <div className="filter-heading"><Button
                                            size="sm"
                                            className='bg-success'
                                            onClick={handleOpenVitals}
                                        >
                                        Manage Vitals
                                        </Button></div>
                                    <div>
                                        {vitals.filter(v => v.is_active !== 0).length === 0 ? (
                                            <div className="text-muted text-center">No vitals selected</div>
                                        ) : (
                                            <Row>
                                                {vitals
                                                    .filter(v => v.is_active !== 0)
                                                    .map((vital, index) => {
                                                        const master = vitalOptions.find(
                                                            (v) => v.id === vital.vital_sign_id
                                                        );

                                                        const getIcon = (short) => {
                                                            const commonProps = {
                                                                width: 20,
                                                                height: 20,
                                                                fill: "none",
                                                                stroke:
                                                                    short === "O2" ? "#0dcaf0" :
                                                                        short === "BS" ? "#dc3545" :
                                                                            short === "Resp" ? "#6c757d" :
                                                                                "currentColor",
                                                                strokeWidth: 2,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            };

                                                            switch (short) {
                                                                case "BP": // Stethoscope
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M6 2v6a4 4 0 0 0 8 0V2" />
                                                                            <path d="M10 14a6 6 0 0 0 12 0" />
                                                                            <circle cx="22" cy="14" r="1" />
                                                                        </svg>
                                                                    );

                                                                case "Temp": // Thermometer
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M10 14a4 4 0 1 0 4 0V5a2 2 0 1 0-4 0z" />
                                                                        </svg>
                                                                    );

                                                                case "Pulse": // Heart
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 22l7.8-8.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
                                                                        </svg>
                                                                    );

                                                                case "Weight": // Weighing scale (🔥 improved)
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <rect x="4" y="4" width="16" height="16" rx="3" />
                                                                            <path d="M12 8v4" />
                                                                            <circle cx="12" cy="12" r="1" />
                                                                        </svg>
                                                                    );

                                                                case "Resp":
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M3 12c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
                                                                            <path d="M3 16c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
                                                                        </svg>
                                                                    );

                                                                case "BS":
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M12 2C8 8 6 10 6 14a6 6 0 0 0 12 0c0-4-2-6-6-12z" />
                                                                            <circle cx="12" cy="14" r="1.5" />
                                                                        </svg>
                                                                    );

                                                                case "O2":
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <path d="M12 3v10" />
                                                                            <path d="M12 13c-3-4-7-4-7 1v3c0 3 2 4 5 4" />
                                                                            <path d="M12 13c3-4 7-4 7 1v3c0 3-2 4-5 4" />
                                                                        </svg>
                                                                    );

                                                                case "Pain": // Grimace face (🔥 like your image)
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <circle cx="12" cy="12" r="10" />
                                                                            <path d="M8 10l2-2M10 10l-2-2" /> {/* left eye */}
                                                                            <path d="M14 10l2-2M16 10l-2-2" /> {/* right eye */}
                                                                            <path d="M8 16l2-1 2 1 2-1 2 1" /> {/* zigzag mouth */}
                                                                        </svg>
                                                                    );

                                                                default:
                                                                    return (
                                                                        <svg {...commonProps} viewBox="0 0 24 24">
                                                                            <rect x="3" y="3" width="18" height="18" rx="2" />
                                                                        </svg>
                                                                    );
                                                            }
                                                        };
                                                        return (
                                                            <Col md={2} key={index} className="mb-3">
                                                                <div className="vital-card-enhanced">

                                                                    {/* Header */}
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <div className="vital-title">
                                                                            {master?.name}
                                                                        </div>

                                                                        <div className="vital-icon">
                                                                            {getIcon(master?.short_name)}
                                                                        </div>
                                                                    </div>

                                                                    {/* Values */}
                                                                    <div className="vital-values">
                                                                        {master?.data_type === "dual" ? (
                                                                            <>
                                                                                <div className="fw-semibold">
                                                                                    {vital.threshold_min} / {vital.threshold_min_2}
                                                                                </div>
                                                                                <div className="text-muted small">
                                                                                    to {vital.threshold_max} / {vital.threshold_max_2}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <div className="fw-semibold">
                                                                                {vital.threshold_min} - {vital.threshold_max}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* Unit */}
                                                                    <div className="vital-unit text-muted small mt-1">
                                                                        ({master?.unit || "N/A"})
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                            </Row>
                                        )}
                                    </div>
                                </div>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_medsheet"
                                        id='is_medsheet'
                                        disabled = {is_dc}
                                        checked={
                                            formData.is_medsheet
                                        }
                                        onChange={(e) => {
                                            if (formData.is_medsheet && !e.target.checked) {
                                                if (!window.confirm("Are you sure you want to turn off Medsheet?")) {
                                                    return;
                                                }
                                            }
                                            setIsDirty(true);
                                            setFormData({
                                                ...formData,
                                                is_medsheet: e.target.checked,
                                            });
                                        }}
                                        label='Medsheet'
                                    />
                                </Col>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_treatment"
                                        id='is_treatment'
                                        disabled = {is_dc}
                                        checked={
                                            formData.is_treatment
                                        }
                                        onChange={e => {
                                            setIsDirty(true);
                                            setFormData({
                                                ...formData,
                                                is_treatment: e.target.checked
                                            })
                                        }}
                                        label='Treatment'
                                    />
                                </Col>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_physpres"
                                        id='is_physpres'
                                        disabled = {is_dc}
                                        checked={
                                            formData.is_physpres
                                        }
                                        onChange={e => {
                                            setIsDirty(true);
                                            setFormData({
                                                ...formData,
                                                is_physpres: e.target.checked
                                            })
                                        }}
                                        label='Physician Order'
                                    />
                                </Col>
                                {/* <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_vital"
                                        id='is_vital'
                                        disabled = {is_dc}
                                        checked={
                                            formData.is_vital
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_vital: e.target.checked
                                            })
                                        }
                                        label='Vital Signs'
                                    />
                                </Col> */}
                            </Row>
                            {/* <Row className="mb-2">
                                <Col>
                                    <Form.Label>Attach Document</Form.Label>
                                    <Form.Control type="file" size="sm" />
                                </Col>
                                <Col>
                                </Col>
                            </Row> */}
                            <Row>
                                {is_dcText != '' && <Col className="d-flex justify-content-center">
                                    <Form.Group className="w-75 mt-4 text-center">
                                     <Form.Label className="fw-bold">Discontinued Note</Form.Label>   
                                    <div className="text-danger fw-bold">{is_dcText}</div>
                                    </Form.Group>
                                </Col>}
                            </Row>
                            <Row>
                                {is_dc ? <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_reActivate"
                                        id='is_reActivate'
                                        className="fs-5"
                                        checked={
                                            formData.is_reActivate
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_reActivate: e.target.checked
                                            })
                                        }
                                        label='Re-Activate Prescription'
                                    />
                                </Col> : <Col></Col>}
                                {is_dc && <Col className="d-flex justify-content-center">
                                        <Form.Group className="w-75 mt-4 text-center">
                                        {showVerifyShimmer ? (
                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '38px' }}>
                                                    <Spinner animation="border" role="status" />
                                                </div>
                                            ) : (<Button
                                                    disabled = {!formData.is_reActivate}
                                                    onClick={handleReActivateClick}
                                                    color="primary"
                                                    className="w-100">
                                                    Re-Activate
                                                </Button>)}       
                                        </Form.Group>
                                    </Col>}
                                {modalData && modalData.prescription?.[0]?.is_verified == 0 && (
                                    <Col className="d-flex justify-content-center">
                                        <Form.Group className="w-75 mt-4 text-center">
                                            {showVerifyShimmer ? (
                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '38px' }}>
                                                    <Spinner animation="border" role="status" />
                                                </div>
                                            ) : (
                                                <Button
                                                    disabled = {is_dc}
                                                    onClick={handleVerifyClick}
                                                    // color="green"
                                                    className="w-100">
                                                    Update & Verify
                                                </Button>
                                            )}
                                        </Form.Group>
                                    </Col>
                                )}
                                
                                <Col className="d-flex justify-content-center">
                                    <Form.Group className="w-75 mt-4 text-center">
                                        {showShimmer ? (
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '38px' }}>
                                                <Spinner animation="border" role="status" />
                                            </div>
                                        ) : (
                                            <Button
                                            disabled = {is_dc}
                                             type="submit" color="primary" className="w-100">
                                                {locationData.orderid != null ? "Update" : "Save"}
                                            </Button>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Modal show={showVitals} onHide={handleCloseModal} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Manage Vitals</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <VitalsChecklistModal
                                masterVitals={vitalOptions}
                                selectedVitals={selectedVitals}
                                vitals={vitals}
                                setVitals={setVitals}
                                validateVitalsParent={validateVitalsParent}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="primary" onClick={handleCloseModal} >
                                Save
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <PrescriptionModal show={showModal} setShow={setShowModal} handlePrescriptionModalValue={handlePrescriptionModalValue} />
                </Form >
            </> : <ShimmerUI />}
        </>
    );
};

AddEditPrescription.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

AddEditPrescription.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default AddEditPrescription;

